import { mockBasketQuote } from '@domgen/dgx-fe-basket';
import { CheckoutCompletedQuote } from '../../models/checkout-completed-item/checkout-completed-quote.interface';
import { CheckoutResponse } from '../../models/checkout/checkout-response.interface';
import { mockCheckoutCompletedQuote } from '../checkout-completed-item/checkout-completed-quote.mock';

export const mockCheckoutResponseQuote: CheckoutResponse<CheckoutCompletedQuote> =
  {
    completedItems: [mockCheckoutCompletedQuote],
    basket: mockBasketQuote,
  };
